import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterPerformance_template} from "../components/templates/newsletterPerformance_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class newsletterPerformance extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected newsletterPerformance_template: newsletterPerformance_template;

    protected getModuleName(){

        return "newsletterPerformance";
    }

    buildContent() : Array<Element>{

        this.newsletterPerformance_template = new newsletterPerformance_template( "newsletterPerformance", this.viewModel, this );
        this.template = this.newsletterPerformance_template;

        return [this.newsletterPerformance_template.build()];
    }

    public fillPage() : void{

        this.newsletterPerformance_template.buildDatePickerCalendar();

        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/newsletter_performance/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.newsletterPerformance_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();

                // LOADING : ends
                obj.loadingOut(obj.newsletterPerformance_template.builtTemplate);
            });
        }
    }

    public getListData(): void{

        let subViewModel = this.newsletterPerformance_template.getViewModelForRequest();
        let baseApiUrl = '/api/newsletter_performance/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.newsletterPerformance_template.resetSelectedRows();
                obj.newsletterPerformance_template.validationsList.clearMessages();
                obj.updateList(responseParsed);

                // LOADING : ends
                let listResults = obj.newsletterPerformance_template.builtTemplate.children.namedItem("list-results");
                obj.loadingOut(listResults || obj.newsletterPerformance_template.builtTemplate);
            });
        };
    }

    protected updateFilters(responseParsed: any){

        this.newsletterPerformance_template.setBrandFilterItems(responseParsed.portfolios);
    }

    protected updateList(responseParsed: any) {

        this.newsletterPerformance_template.setNewsletterData(responseParsed.newsletterData || []);
        this.newsletterPerformance_template.setNewsletterTotalData(responseParsed.newsletterTotalData || []);
        this.newsletterPerformance_template.setTotalSubscribers(responseParsed.totalUniqueSubscribers);
    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    protected filterDateOnChange(){

        this.getListData();
    }

    public filterEspOnChange(){
        this.getListData();
    }

    public listReorder(){

        this.getListData();
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletterPerformance.ts